import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { getGallery } from '../Service/Api';
import LazyLoad from 'react-lazyload';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function HomeGallery() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const galleryData = await getGallery();
        setData(galleryData);
        console.log(galleryData)
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };
    fetchData();
  }, []);

  const emptyArray = [
    { title: "Gallery Title", day: "DD", month: "MM", attachments: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/gallery1.png", description: "Stay tuned for latest updates" },
    { title: "Gallery Title", day: "DD", month: "MM", attachments: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/gallery2.png", description: "Stay tuned for latest updates" },
    { title: "Gallery Title", day: "DD", month: "MM", attachments: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/gallery3.png", description: "Stay tuned for latest updates" },
    { title: "Gallery Title", day: "DD", month: "MM", attachments: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/gallery4.png", description: "Stay tuned for latest updates" }
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }
    ]
  };
  return (
    <div className="slider-container">
      <br />
      <Slider {...settings}>
        {data.length > 0 ? (
          data
            .filter(item => item.category === "PhotoGallery")
            .slice(0, 8) // Adjust number of slides to show
            .map((item, index) => (
              <div key={index} className="galiImg">
                <Link to='/Gallery'>
                  <img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`} className='img-fluid' alt="St. Mary Bokaro" />
                </Link>
              </div>
            ))
        ) : (
          emptyArray.map((data, index) => (
            <div key={index} className="galiImg">
              <Link to='/photogallery'>
                <img src={data.attachments} className='img-fluid' alt={data.title} />
              </Link>
            </div>
          ))
        )}
      </Slider>
    </div>
  );
}
export default HomeGallery;
